module.exports = __webpack_public_path__ + "img/user-right-01.a6164bd2.svg";